import { render, staticRenderFns } from "./FeedbackAnalyticsTable.vue?vue&type=template&id=31a07b3c&"
import script from "./FeedbackAnalyticsTable.vue?vue&type=script&lang=js&"
export * from "./FeedbackAnalyticsTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports